import * as yup from 'yup';

import { FORM_FIELDS } from '@constants/form';

export const PROMOTION = FORM_FIELDS.PROMOTION;
export const MODAL = PROMOTION.MODAL;

export const promotionFormValidation = yup.object().shape({
  [MODAL.NAME]: yup.string().required('Name is required'),
});

export type PromotionFormDataType = yup.InferType<
  typeof promotionFormValidation
>;
